const SKIP_DURATION_MS = 24 * 60 * 60 * 1000;

const skipKey = (companyId: number) => `connect-company-skipped:${companyId}`;

// Storage throws when it is disabled or out of quota, which must never break the overlay.
export const isSkipped = (companyId: number) => {
	try {
		const skippedAt = Number(window.localStorage.getItem(skipKey(companyId)));
		return skippedAt > 0 && Date.now() - skippedAt < SKIP_DURATION_MS;
	} catch {
		return false;
	}
};

export const skipForADay = (companyId: number) => {
	try {
		window.localStorage.setItem(skipKey(companyId), Date.now().toString());
	} catch {
		return;
	}
};
